// extracted by mini-css-extract-plugin
export var label = "_bq-1";
export var reminder = "_bq-0";